import IBAN from 'iban';

const iban = function(iban) {
  if (!iban) {
    return true
  }
  
  if(iban.substr(0,2) == parseInt(iban.substr(0,2))) iban = "PL"+iban;

  return IBAN.isValid(iban);

  return false
}

export default iban
